/* @jsx h */
import { defineComponent, h } from "vue";
import { useLocalization } from "@lemmonhq/uikit";
import type { TabValue } from "../config";
import { TAB_CONFIG } from "../config";

interface ErrorStateProps {
  tab: TabValue;
  error: string;
  onRetry: () => void;
}

export const ErrorState = defineComponent<ErrorStateProps>({
  name: "ErrorState",
  props: ["tab", "error", "onRetry"] as any,
  setup(props) {
    const { t } = useLocalization();

    return () => {
      const config = TAB_CONFIG[props.tab];

      return (
        <div class="flex items-center justify-center h-full min-h-[400px]">
          <div class="text-center bg-base-100 rounded-xl p-8 shadow-sm max-w-md">
            <div class="w-12 h-12 rounded-full bg-error/10 flex items-center justify-center mx-auto mb-4">
              <span class="material-symbols-outlined text-error text-2xl">
                error
              </span>
            </div>
            <h3 class="font-medium text-accent mb-2">
              {t(config.errorTitleKey)}
            </h3>
            <p class="text-sm text-base-content/60 mb-4">{props.error}</p>
            <button onClick={props.onRetry} class="btn btn-primary btn-sm">
              <span class="material-symbols-outlined text-sm">refresh</span>
              {t("reservations.general.try_again")}
            </button>
          </div>
        </div>
      );
    };
  },
});
